import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'
import { AuthShell, Field } from './Login'

export default function Signup() {
  const { signup } = useAuth()
  const navigate = useNavigate()
  const [orgName, setOrgName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    setLoading(true)
    try {
      // Public signup always lands on the Free tier (2-VM cap); the AuthProvider
      // pins plan=free so a bargain account can never self-provision a paid tier.
      await signup(orgName.trim(), email.trim(), password)
      navigate('/vms', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign up failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell title="Create your VoltVisor account" subtitle="Free tier — spin up to 2 VMs">
      <form onSubmit={submit} className="space-y-4">
        {error && (
          <div className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}
        <Field label="Workspace name" value={orgName} onChange={setOrgName} autoComplete="organization" required hint="Your team / project name" />
        <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" required />
        <Field label="Password" type="password" value={password} onChange={setPassword} autoComplete="new-password" required hint="At least 8 characters" />
        <button
          type="submit"
          disabled={loading}
          className="w-full inline-flex items-center justify-center rounded-lg bg-voltainer-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-voltainer-700 focus:outline-none focus:ring-2 focus:ring-voltainer-500 focus:ring-offset-2 disabled:opacity-50"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
          Create account
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-gray-400">
        Already have an account?{' '}
        <Link to="/login" className="font-medium text-voltainer-400 hover:text-voltainer-300">
          Sign in
        </Link>
      </p>
    </AuthShell>
  )
}
